import "@story/story_assets/dom_extend";
import "@story/story_assets/modal/modal_dialog"
import "@story/story_assets/slide";

//= require story_assets/ajax
//= require story_assets/cookies
//= require story_assets/slide
//= require story_assets/modal/modal_dialog
//= require story_cookies_consent/cookies_consent
//= require story_cookies_consent/cookies_consent_link

import "./components/cookies_consent_dialog";
import "./components/gtm_events";
import "./components/timer";

document.addEventSelectorListener("click", "[data-clamp]", function(event, trigger) {
	event.preventDefault();
	let target = document.querySelector(trigger.getAttribute("data-clamp"));
	target.classList.toggle("expanded");

	if (target.classList.contains("expanded")) {
		// Open
		trigger.trigger("clamp:expanding");
	}
	else {
		// Close
		trigger.trigger("clamp:collapsing");
	}
});


document.addEventSelectorListener("click", "a[href]", function(event, element) {
	let anchor = element.getAttribute("href");
	if (!anchor || !(anchor.startsWith("#") || (document.location.pathname == "/" && anchor.startsWith("/#"))) || anchor == "#") {
		return;
	}

	anchor = anchor.replace(/^\/+/, "")

	event.preventDefault();
	let target = document.querySelector(anchor);
	if (!target) {
		return;
	}

	target.scrollIntoView({
		behavior: "smooth",
		block: "start"
	});
});

document.addEventSelectorListener("click", "[data-video-play]", function(event, element) {
	event.preventDefault();
	const target = document.querySelector(element.getAttribute("data-video-play"));
	if (!target) {
		return;
	}

	const iframe = target.querySelector("iframe");
	if (!iframe) {
		return;
	}

	const player = new Vimeo.Player(iframe);
	player.play();
});